module.exports = __webpack_public_path__ + "static/assets/a3a870d4dd17d77183dd3817128d50d6.svg";